module.exports = __webpack_public_path__ + "img/Ranking-mobile.8f4ea11b.webp";